/**
 * Determines whether it is a valid UUID
 * @param u
 */
export const isValidUUID = (u: string): boolean => {
  return String(u).match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$') !== null;
};
